import { render, staticRenderFns } from "./tabCardTransactions.vue?vue&type=template&id=9498d6c6&"
import script from "./tabCardTransactions.vue?vue&type=script&lang=js&"
export * from "./tabCardTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports